export default __webpack_public_path__ + "static/media/scritta.b0aa05ed.svg";